import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
const browser = require("browser-size")();
const randomstring = require("randomstring");
const VueCookie = require("vue-cookie");

import { ajaxGet, ajaxPost } from "@/helpers/ajax";

Vue.use(Vuex);

const mobileBreakpoint = 800; // change in _settings.scss too!

const relevantStats = ["effekthoehe", "kaliber", "laenge", "schuss", "teile"];

const returnStats = function(products) {
  if (typeof products === "object") {
    const stats = {};
    relevantStats.forEach((el) => {
      stats[el] = 0;
    });
    products.forEach((p) => {
      relevantStats.forEach((s) => {
        if (stats[s] < parseInt(p[s])) {
          stats[s] = parseInt(p[s]);
        }
      });
    });
    return stats;
  } else {
    return false;
  }
};

const sortProducts = function(a, b) {
  // tv spot should always be first
  if (a.tvSpot && !b.tvSpot) {
    // only a has tvspot
    return -1;
  }
  if (!a.tvSpot && b.tvSpot) {
    // only b has tvspot
    return 1;
  }
  if (a.tvSpot && b.tvSpot) {
    // both have tvspot
    return 0;
  }

  // which has higher priority?
  if (a.sortierungHoch && !b.sortierungHoch) {
    // only a has high priority
    return -1;
  }
  if (!a.sortierungHoch && b.sortierungHoch) {
    // only b has high priority
    return 1;
  }
  if (a.sortierungHoch && b.sortierungHoch) {
    // both have high priority
    return 0;
  }
};

export default new Vuex.Store({
  state: {
    jumpToList: false,

    loading: false,

    showScrollbar: true, // shows/hides globalscrollbar
    bodyNoOverflow: false,
    dialogOpen: false,
    showShoppinglist: false,

    homeScrollPosition: 0,

    pics: false,
    copies: false,

    zip: null,
    market: false,
    products: [],
    allProducts: [],
    stats: false,

    categories: false,

    filters: [],
    showAllProducts: false,

    shoppinglistKey: false,
    shoppinglistSecret: false,
    shoppinglist: [],
  },
  mutations: {
    SET_JUMPTOLIST(state, payload) {
      Vue.set(state, "jumpToList", payload);
    },

    SET_LOADING(state, payload) {
      Vue.set(state, "loading", payload);
    },
    SET_SHOW_SHOPPINGLIST(state, payload) {
      Vue.set(state, "showShoppinglist", payload);
    },

    SET_HOMESCROLLPOSITION(state, payload) {
      Vue.set(state, "homeScrollPosition", payload);
    },

    SET_COPIES(state, payload) {
      Vue.set(state, "copies", payload || false);
    },

    SET_PICS(state, payload) {
      Vue.set(state, "pics", payload || false);
    },

    SET_MARKET(state, payload) {
      Vue.set(state, "market", payload || false);
    },
    SET_PRODUCTS(state, payload) {
      if (JSON.stringify(payload) !== JSON.stringify(state.products)) {
        Vue.set(state, "products", payload || []);
      }
    },
    SET_ALL_PRODUCTS(state, payload) {
      Vue.set(state, "allProducts", payload || []);
    },
    SET_STATS(state, payload) {
      Vue.set(state, "stats", payload);
    },
    SET_FILTERS(state, payload) {
      const filters = !payload || payload.length > 0 ? payload : [];
      Vue.set(state, "filters", payload);
    },
    SET_SHOW_ALL(state, payload) {
      Vue.set(state, "showAllProducts", payload);
    },
    SET_ZIP(state, payload) {
      Vue.set(state, "zip", payload);
    },
    SET_SHOW_SCROLLBAR(state, payload) {
      Vue.set(state, "showScrollbar", payload);
    },
    SET_BODY_NO_OVERFLOW(state, payload) {
      Vue.set(state, "bodyNoOverflow", payload);
    },
    SET_DIALOG_OPEN(state, payload) {
      Vue.set(state, "dialogOpen", payload);
    },
    SET_CATEGORIES(state, payload) {
      Vue.set(state, "categories", payload);
    },

    SET_SHOPPINGLIST(state, payload) {
      Vue.set(state, "shoppinglist", payload.items);
    },

    SET_SHOPPINGLISTKEY(state, payload) {
      Vue.set(state, "shoppinglistKey", payload);
    },

    SET_SHOPPINGLISTSECRET(state, payload) {
      Vue.set(state, "shoppinglistSecret", payload);
    },

    ADD_SHOPPINGLIST_ITEM(state, produktnummer) {
      let item = state.shoppinglist.find((el) => el.nr === produktnummer);
      if (item) {
        Vue.set(item, "count", item.count + 1);
      } else {
        state.shoppinglist.push({
          nr: produktnummer,
          count: 1,
          added: new Date().getTime(),
        });
      }
    },

    UPDATE_SHOPPINGLIST_COUNT(state, payload) {
      let item = state.shoppinglist.find(
        (el) => el.nr === payload.produktnummer
      );
      if (item) {
        if (payload.count > 0) {
          item.count = payload.count;
        }
      }
    },

    REMOVE_SHOPPINGLIST_ITEM(state, produktnummer) {
      const itemIndex = state.shoppinglist.findIndex(
        (el) => el.nr === produktnummer
      );
      state.shoppinglist.splice(itemIndex, 1);
    },
  },
  actions: {
    // INITIAL WHEN APP STARTS
    storeShoppinglistSecret({ state, commit }) {
      const cookieKey = VueCookie.get("fwlsk");
      const cookieSecret = VueCookie.get("fwlss");
      if (cookieKey && cookieSecret) {
        commit("SET_SHOPPINGLISTKEY", cookieKey);
        commit("SET_SHOPPINGLISTSECRET", cookieSecret);
      } else {
        const randomKey = randomstring.generate(10);
        const randomSecret = randomstring.generate(10);
        commit("SET_SHOPPINGLISTKEY", randomKey);
        commit("SET_SHOPPINGLISTSECRET", randomSecret);
        VueCookie.set("fwlsk", randomKey, 3);
        VueCookie.set("fwlss", randomSecret, 3);
      }
    },

    getCopies: async ({ commit, state }) => {
      const response = await ajaxGet("copies.json");
      commit("SET_COPIES", response);
    },

    getPics: async ({ commit, state }) => {
      const response = await ajaxGet("pics.json");
      commit("SET_PICS", response);
    },

    getCategories: async ({ commit, state }) => {
      const response = await ajaxGet("categories.json");
      commit("SET_CATEGORIES", response.categories);
    },

    getAllProducts: async ({ commit }, marktIdentNr) => {
      const response = await ajaxGet(`products.json`);
      commit("SET_ALL_PRODUCTS", response.products);
      commit("SET_STATS", returnStats(response.products));
    },

    getPreviewProducts: async ({ commit }) => {
      const response = await ajaxGet(`productsPreview.json`);
      commit("SET_ALL_PRODUCTS", response.products);
    },

    // SHOPPINGLIST
    getShoppinglistPrivate: async ({ commit, state }) => {
      const response = await ajaxGet(
        `shoppinglist/get/${state.shoppinglistKey}/${state.shoppinglistSecret}`
      );
      commit("SET_SHOPPINGLIST", response.data);
    },

    getShoppinglistPublic: async ({ commit, state }, key) => {
      const response = await ajaxGet(`shoppinglist/public/${key}`);
      return response.data;
    },

    addShoppinglistItem: async ({ commit, dispatch, state }, produktnummer) => {
      commit("ADD_SHOPPINGLIST_ITEM", produktnummer);
      dispatch("updateShoppinglistData");
    },

    removeShoppinglistItem: async (
      { commit, dispatch, state },
      produktnummer
    ) => {
      commit("REMOVE_SHOPPINGLIST_ITEM", produktnummer);
      dispatch("updateShoppinglistData");
    },

    updateShoppinglistData: async ({ state }) => {
      const response = await ajaxPost(
        `shoppinglist/set/${state.shoppinglistKey}/${state.shoppinglistSecret}`,
        { list: state.shoppinglist, market: state.market },
        true
      );
    },

    // PRODUCTS AND MARKETS
    getProducts: async ({ commit, state }, marktIdentNr) => {
      commit("SET_LOADING", true);
      const response = await ajaxGet(
        `${
          marktIdentNr
            ? `market/${parseInt(marktIdentNr)}.json`
            : "products.json"
        }`
      );
      commit("SET_MARKET", response.market);
      commit("SET_PRODUCTS", response.products);
      commit("SET_LOADING", false);
    },

    getMarketProducts: async ({ commit }, marktIdentNr) => {
      const response = await ajaxGet(
        `${
          marktIdentNr
            ? `market/${parseInt(marktIdentNr)}.json`
            : "products.json"
        }`
      );
      return response.products;
    },

    getProduct: async ({ commit, state }, produktnummer) => {
      commit("SET_LOADING", true);
      let product = state.products.find((el) => {
        return el.nr === produktnummer;
      });
      if (!product) {
        const response = await ajaxGet(
          `product/${parseInt(produktnummer)}.json`
        );
        commit("SET_PRODUCTS", state.products.concat(response.product));
      }
      commit("SET_LOADING", false);
    },
  },
  getters: {
    isMobile: (state) => {
      return browser.width ? browser.width <= mobileBreakpoint : false;
    },
    products: (state) => {
      // return all products if no filter is set
      if (!state.filters || state.filters.length === 0) {
        const products = state.products.sort(sortProducts);
        // Move products with bonusProdukt === true to the beginning of the array
        products.sort((a, b) => {
          if (a.bonusProdukt === b.bonusProdukt) return 0;
          if (a.bonusProdukt) return -1;
          return 1;
        });
        return products;
      }
      // return filtered products
      let thisProducts = [];
      thisProducts = state.products.filter((p) => {
        // return product if it has no categories
        // return !p.categories || p.categories.length === 0
        let found = false;
        state.filters.forEach((f) => {
          if (
            p.categories.indexOf(f) > -1 ||
            (f === "video" && p.youtubeId && p.youtubeId.length > 0)
          ) {
            found = true;
          }
        });
        return found;
      });

      // sort products

      return thisProducts.sort(sortProducts);
    },
    product: (state) => (produktnummer) => {
      return state.products.find((el) => el.nr === produktnummer) || {};
    },
    shoppinglistItem: (state) => (produktnummer) => {
      return state.shoppinglist.find((el) => el.nr === produktnummer);
    },
    shoppinglistItems: (state) => {
      const items = [];
      state.shoppinglist.forEach((item) => {
        let product = state.allProducts.find((el) => el.nr === item.nr);
        if (product) {
          const shoppinglistItem = state.shoppinglist.find(
            (el) => el.nr === item.nr
          );
          product.available = state.products.find((el) => el.nr === item.nr)
            ? true
            : false;
          product.count = shoppinglistItem.count;
          product.added = shoppinglistItem.added;
          items.push(product);
        }
      });
      items.sort((a, b) =>
        a.added > b.added ? -1 : a.added < b.added ? 1 : 0
      );
      return items;
    },
    shoppinglistCount: (state) => {
      let count = 0;
      state.shoppinglist.forEach((item) => {
        count = count + item.count;
      });
      return count;
    },
    highlightProducts: (state) => {
      return state.allProducts.slice(0, 12);
    },
  },
});
